<template>
  <div style='width:80vw; margin-left: auto; margin-right: auto;'>
    <b-card no-body class='shadow-sm p-0 m-0 bg-white rounded'>
      <b-card-body class='p-0 m-0'>
        <b-row>
          <b-col class='pl-4'>
            <h4 id='traffic' class='card-title mb-0'>達成度</h4>
            <div class='small text-muted'>{{ rankStart }} - {{ rankEnd }}</div>
          </b-col>
        </b-row>
        <b-card-body>
          <b-row class='d-flex justify-content-center mb-2'>
            <b-button-toolbar key-nav  aria-label='Toolbar with button groups'>
              <b-button-group class='mx-1'>
                <b-btn v-if="selected != 'Month'" variant='outline-primary' v-on:click='rew()'>&laquo;</b-btn>
                <b-btn variant='outline-primary' v-on:click='left()'>&lsaquo;</b-btn>
              </b-button-group>
              <b-button-group class='mx-1'>
                <b-btn variant='outline-primary' v-on:click='today()'>本日</b-btn>
              </b-button-group>
              <b-button-group class='mx-1'>
                <b-btn variant='outline-primary' v-on:click='right()'>&rsaquo;</b-btn>
                <b-btn v-if="selected != 'Month'" variant='outline-primary' v-on:click='ff()'>&raquo;</b-btn>
              </b-button-group>
            </b-button-toolbar>
            <b-button-toolbar key-nav aria-label='Toolbar with button groups'>
              <b-form-radio-group class='mr-3' id='radiosBtn' buttons button-variant='outline-primary' v-model='selected' name='radiosBtn'>
                <b-form-radio class='select-btn' value='Month' button-variant='outline-danger'>月</b-form-radio>
                <b-form-radio class='select-btn' value='Week' button-variant='outline-success'>週</b-form-radio>
                <b-form-radio class='select-btn' value='Day'  button-variant='outline-primary'>日</b-form-radio>
              </b-form-radio-group>
            </b-button-toolbar>
          </b-row>
          <b-row class='d-flex justify-content-center'>
            <b-col sm='12' lg='10' class='p-0'>
              <b-card :class='bgColor' class='p-0 m-0'>
                <bar-chart class='chart-wrapper p-0 m-0' :chartData='chartData' :options='options' height='240'/>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card-body>
      <b-card-body v-if="isRoutine" border-variant='white' class='p-0' no-body>
        <b-row>
          <b-col class='pl-4'>
            <h4 id='traffic' class='card-title mb-0'>ルーティン</h4>
            <div class='small text-muted'>{{ rankStart }} - {{ rankEnd }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class='p-0'>
            <b-card-body>
              <b-row class='d-flex justify-content-center'>
                <b-col sm='12'>
                <div class='table-responsive'>
                  <b-table
                    responsive
                    :items='statusTable'
                    :fields='fields'
                    >
                    <div slot='icon' class='avatar' slot-scope='item'>
                      <b-img v-if='item.value' :src='item.value' width='40' height='40'></b-img>
                      <!-- <b-img v-else src='../admin.png' width='40' height='40' class='img-avatar'></b-img> -->
                    </div>
                    <div slot='title' slot-scope='item'>
                      <p v-if='item.item.type == "self"' class='p-0 m-0'>{{ item.value }}</p>
                      <p v-else class='p-0 m-0'>【共通】{{ item.value }}</p>
                    </div>
                    <div slot='category' slot-scope='item'>
                      <p class='p-0 m-0'>[{{categoryText(item.value)}}]</p>
                    </div>
                    <div slot='day0' slot-scope='item'>
                      <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                    </div>
                    <div slot='day1' slot-scope='item'>
                      <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                    </div>
                    <div slot='day2' slot-scope='item'>
                      <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                    </div>
                    <div slot='day3' slot-scope='item'>
                      <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                    </div>
                    <div slot='day4' slot-scope='item'>
                      <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                    </div>
                    <div slot='day5' slot-scope='item'>
                      <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                    </div>
                    <div slot='day6' slot-scope='item'>
                      <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                    </div>
                    <div slot='total' slot-scope='item'>
                      <p class='p-0 m-0'>{{ item.value }}%</p>
                    </div>
                  </b-table>
                </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import BarChart from '@/components/BarChart'
import { mapGetters } from 'vuex'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)
export default {
  data () {
    return {
      active: ['1'],
      offsetLocal: 0,
      week: Array(52),
      month: Array(13),
      rankStart: null,
      rankEnd: null,
      chartData: {},
      options: {},
      selected: 'Day',
      bgColor: 'bg-primary',
      isRoutine: true,
      isSelected: false,
      statusTable: [],
      items: {},
      fields: {
        title: {
          label: 'ルーティン',
          class: 'text-left small p-0',
          sortable: true
        },
        category: {
          label: 'カテゴリー',
          class: 'text-center small p-0',
          sortable: true
        },
        day0: {
          label: '',
          class: 'th-date small p-0'
        },
        day1: {
          label: '',
          class: 'th-date small p-0'
        },
        day2: {
          label: '',
          class: 'th-date small p-0'
        },
        day3: {
          label: '',
          class: 'th-date small p-0'
        },
        day4: {
          label: '',
          class: 'th-date small p-0'
        },
        day5: {
          label: '',
          class: 'th-date small p-0'
        },
        day6: {
          label: '',
          class: 'th-date small p-0'
        },
        total: {
          label: '達成度',
          class: 'text-center small p-0',
          sortable: true
        }
      },
      currentPage: 1,
      perPage: 10,
      routineData: [],
      routineSelf: []
    }
  },
  components: {
    BarChart
  },
  props: ['user', 'offset'],
  created () {
    this.offsetLocal = this.localOffset
    this.fillData()
    this.getRoutineData().then(() => {
      this.getRoutineSelf().then(() => {
        this.calcStatics()
        this.fillData()
        this.calcStatusTable()
      })
    })
  },
  watch: {
    selected: function () {
      if (!this.isSelected) {
        this.offsetLocal = 0
      }
      this.fillData()
      if (this.selected === 'Day') {
        this.bgColor = 'bg-primary'
        this.isRoutine = true
      } else if (this.selected === 'Week') {
        this.bgColor = 'bg-success'
        this.isRoutine = false
      } else {
        this.bgColor = 'bg-danger'
        this.isRoutine = false
      }
      this.isSelected = false
      this.calcStatusTable()
    },
    user: function () {
      this.fillData()
    }
  },
  methods: {
    isDateValid (item) {
      var status = false
      const range = moment.range(item.startAt, item.endAt)
      for (var i = 0; i < 7; i++) {
        var objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 + this.offsetLocal + i)
        var str = moment(objDate).format('YYYY/MM/DD')
        var state = { date: str }
        var today = parseInt(moment(Date.parse(state.date)).format('X'))
        if (range.contains(today)) {
          status = true
          break
        }
      }
      return status
    },
    setRoutines (temp, id) {
      var objDate = new Date()
      objDate.setDate(objDate.getDate() - 6 + this.offsetLocal)
      var str = moment(objDate).format('YYYY/MM/DD')
      for (var x in temp) {
        const payload = {
          type: id,
          key: temp[x].key,
          date: str,
          day0: 0,
          day1: 0,
          day2: 0,
          day3: 0,
          day4: 0,
          day5: 0,
          day6: 0,
          total: 100,
          title: temp[x].title,
          category: temp[x].category
        }
        this.statusTable.push(payload)
      }
    },
    createMyRoutine () {
      this.statusTable = []
      var temp = []
      var keys = Object.keys(this.user.services)
      for (var i in keys) {
        if (this.user.services[keys[i]]) {
          var index = this.services.findIndex(service => service.key === keys[i])
          if (index !== -1) {
            for (var x in this.services[index].routine) {
              var rIndex = this.routineRefs.findIndex(r => r.key === this.services[index].routine[x])
              if (rIndex !== -1 && this.isDateValid(this.routineRefs[rIndex])) {
                var gIndex = this.routineGroups.findIndex(rg => rg.key === this.routineRefs[rIndex].routine_ref)
                if (gIndex !== -1) {
                  for (var y in this.routineGroups[gIndex].routines) {
                    var r = this.routines.findIndex(r => r.key === this.routineGroups[gIndex].routines[y])
                    if (r !== -1) {
                      temp.push(JSON.parse(JSON.stringify(this.routines[r])))
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.setRoutines(temp, 'service')
      temp = []
      keys = Object.keys(this.user.groups)
      for (i in keys) {
        if (this.user.groups[keys[i]]) {
          index = this.groups.findIndex(group => group.key === keys[i])
          if (index !== -1) {
            for (x in this.groups[index].routine) {
              rIndex = this.routineRefs.findIndex(r => r.key === this.groups[index].routine[x])
              if (rIndex !== -1 && this.isDateValid(this.routineRefs[rIndex])) {
                gIndex = this.routineGroups.findIndex(rg => rg.key === this.routineRefs[rIndex].routine_ref)
                if (gIndex !== -1) {
                  for (y in this.routineGroups[gIndex].routines) {
                    r = this.routines.findIndex(r => r.key === this.routineGroups[gIndex].routines[y])
                    if (r !== -1) {
                      temp.push(JSON.parse(JSON.stringify(this.routines[r])))
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.setRoutines(temp, 'group')
      temp = []
      for (x in this.user.routine) {
        rIndex = this.routineRefs.findIndex(r => r.key === this.user.routine[x])
        if (rIndex !== -1 && this.isDateValid(this.routineRefs[rIndex])) {
          gIndex = this.routineGroups.findIndex(rg => rg.key === this.routineRefs[rIndex].routine_ref)
          if (gIndex !== -1) {
            for (y in this.routineGroups[gIndex].routines) {
              r = this.routines.findIndex(r => r.key === this.routineGroups[gIndex].routines[y])
              if (r !== -1) {
                temp.push(JSON.parse(JSON.stringify(this.routines[r])))
              }
            }
          }
        }
      }
      this.setRoutines(temp, 'user')
      temp = []
      for (x in this.routineSelf) {
        temp.push(this.routineSelf[x])
      }
      this.setRoutines(temp, 'self')
    },
    getRoutineData () {
      return new Promise((resolve, reject) => {
        var vm = this
        this.routineData = []
        if (!this.user) {
          resolve()
          return
        }
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var dbRef = db.collection('routine_data').doc(vm.user.key).collection('data')
        dbRef.orderBy('createdAt', 'desc').get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const payload = {
              key: doc.id,
              owner: doc.data().owner,
              date: doc.data().date,
              dateText: doc.data().dateText,
              routineCounter: doc.data().routineCounter,
              routineService: doc.data().routineService,
              routineGroup: doc.data().routineGroup,
              routineUser: doc.data().routineUser,
              routineSelf: doc.data().routineSelf,
              createdAt: doc.data().createdAt,
              updatedAt: doc.data().updatedAt
            }
            vm.routineData.push(JSON.parse(JSON.stringify(payload)))
          })
          resolve()
        })
      })
    },
    getRoutineSelf () {
      return new Promise((resolve, reject) => {
        var vm = this
        this.routineSelf = []
        if (!this.user) {
          resolve()
          return
        }
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var dbRef = db.collection('routine_self').doc(vm.user.key).collection('data')
        dbRef.get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            if (vm.authUser.role !== 'user') {
              var routine = JSON.parse(JSON.stringify(doc.data()))
              routine['key'] = doc.id
              vm.routineSelf.push(routine)
            } else if (doc.data().share === true && doc.data().done === false) {
              routine = JSON.parse(JSON.stringify(doc.data()))
              routine['key'] = doc.id
              vm.routineSelf.push(routine)
            }
          })
          resolve()
        })
      })
    },
    calcStatics () {
      this.week.fill(0)
      this.month.fill(0)
      for (var i = 0; i < 364; i++) {
        var objDate = new Date()
        objDate.setDate(objDate.getDate() - (363 - i))
        var str = moment(objDate).format('YYYY/MM/DD')
        const index = this.routineData.findIndex(
          routine => routine.dateText === str
        )
        if (index !== -1) {
          var routine = this.routineData[index]
          this.week[Math.floor(i / 7)] += routine.routineCounter.total.done
          this.month[Math.floor(i / 28)] += routine.routineCounter.total.done
        }
      }
    },
    calcStatusTable () {
      this.createMyRoutine()
      for (var i = 0; i < 7; i++) {
        var objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 + this.offsetLocal + i)
        var str = moment(objDate).format('YYYY/MM/DD')
        var label = 'day' + String(i)
        this.fields[label].label = moment(objDate).format('DD')
        var index = this.routineData.findIndex(
          routine => routine.dateText === str
        )
        if (index !== -1) {
          var data = this.routineData[index]
          for (var key in data.routineService) {
            for (var r in data.routineService[key]) {
              index = this.routines.findIndex(routine => routine.key === r)
              if (index !== -1) {
                var routine = this.routines[index]
                var offset = this.statusTable.findIndex(
                  status => status.key === r
                )
                if (offset === -1) {
                  const payload = {
                    type: 'service',
                    key: r,
                    date: str,
                    day0: null,
                    day1: null,
                    day2: null,
                    day3: null,
                    day4: null,
                    day5: null,
                    day6: null,
                    total: null,
                    title: routine.title,
                    category: routine.category
                  }
                  payload[label] = data.routineService[key][r]
                  if (payload[label] === 2 || payload[label] === 0) {
                    payload.total = 100
                  } else {
                    payload.total = 0
                  }
                  this.statusTable.push(payload)
                } else {
                  var status = this.statusTable[offset]
                  status[label] = data.routineService[key][r]
                  var number = 0
                  var done = 0
                  for (var x = 0; x < 7; x++) {
                    var d = 'day' + String(x)
                    if (this.statusTable[offset][d] !== null) {
                      number += 1
                      if (this.statusTable[offset][d] === 2 || this.statusTable[offset][d] === 0) {
                        done += 1
                      }
                    }
                  }
                  this.statusTable[offset].total = Math.floor(
                    100 * (done / number)
                  )
                }
              }
            }
          }
          for (key in data.routineGroup) {
            for (r in data.routineGroup[key]) {
              index = this.routines.findIndex(routine => routine.key === r)
              if (index !== -1) {
                routine = this.routines[index]
                offset = this.statusTable.findIndex(
                  status => status.key === r
                )
                if (offset === -1) {
                  const payload = {
                    type: 'group',
                    key: r,
                    date: str,
                    day0: null,
                    day1: null,
                    day2: null,
                    day3: null,
                    day4: null,
                    day5: null,
                    day6: null,
                    total: null,
                    title: routine.title,
                    category: routine.category,
                    data: data.routineGroup[key][r]
                  }
                  payload[label] = data.routineGroup[key][r]
                  if (payload[label] === 2 || payload[label] === 0) {
                    payload.total = 100
                  } else {
                    payload.total = 0
                  }
                  this.statusTable.push(payload)
                } else {
                  status = this.statusTable[offset]
                  status[label] = data.routineGroup[key][r]
                  number = 0
                  done = 0
                  for (x = 0; x < 7; x++) {
                    d = 'day' + String(x)
                    if (this.statusTable[offset][d] !== null) {
                      number += 1
                      if (this.statusTable[offset][d] === 2 || this.statusTable[offset][d] === 0) {
                        done += 1
                      }
                    }
                  }
                  this.statusTable[offset].total = Math.floor(
                    100 * (done / number)
                  )
                }
              }
            }
          }
          for (r in data.routineUser) {
            index = this.routines.findIndex(routine => routine.key === r)
            if (index !== -1) {
              routine = this.routines[index]
              offset = this.statusTable.findIndex(
                status => status.key === r
              )
              if (offset === -1) {
                const payload = {
                  type: 'user',
                  key: r,
                  date: str,
                  day0: null,
                  day1: null,
                  day2: null,
                  day3: null,
                  day4: null,
                  day5: null,
                  day6: null,
                  total: null,
                  title: routine.title,
                  category: routine.category,
                  data: data.routineUser[r]
                }
                payload[label] = data.routineUser[r]
                if (payload[label] === 2 || payload[label] === 0) {
                  payload.total = 100
                } else {
                  payload.total = 0
                }
                this.statusTable.push(payload)
              } else {
                status = this.statusTable[offset]
                status[label] = data.routineUser[r]
                number = 0
                done = 0
                for (x = 0; x < 7; x++) {
                  d = 'day' + String(x)
                  if (this.statusTable[offset][d] !== null) {
                    number += 1
                    if (this.statusTable[offset][d] === 2 || this.statusTable[offset][d] === 0) {
                      done += 1
                    }
                  }
                }
                this.statusTable[offset].total = Math.floor(
                  100 * (done / number)
                )
              }
            }
          }
          for (r in data.routineSelf) {
            index = this.routineSelf.findIndex(routine => routine.key === r)
            if (index !== -1) {
              routine = this.routineSelf[index]
              offset = this.statusTable.findIndex(
                status => status.key === r
              )
              if (offset === -1) {
                const payload = {
                  type: 'self',
                  key: r,
                  date: str,
                  day0: null,
                  day1: null,
                  day2: null,
                  day3: null,
                  day4: null,
                  day5: null,
                  day6: null,
                  total: null,
                  title: routine.title,
                  category: routine.category,
                  data: data.routineUser[r]
                }
                payload[label] = data.routineSelf[r]
                if (payload[label] === 2 || payload[label] === 0) {
                  payload.total = 100
                } else {
                  payload.total = 0
                }
                this.statusTable.push(payload)
              } else {
                status = this.statusTable[offset]
                status[label] = data.routineSelf[r]
                number = 0
                done = 0
                for (x = 0; x < 7; x++) {
                  d = 'day' + String(x)
                  if (this.statusTable[offset][d] !== null) {
                    number += 1
                    if (this.statusTable[offset][d] === 2 || this.statusTable[offset][d] === 0) {
                      done += 1
                    }
                  }
                }
                this.statusTable[offset].total = Math.floor(
                  100 * (done / number)
                )
              }
            }
          }
        }
      }
    },
    rew () {
      var value = this.offsetLocal - 7
      if (this.selected === 'Week') {
        if (value < -45) {
          value = -45
        }
      } else {
        if (value < -358) {
          value = -358
        }
      }
      this.offsetLocal = value
      this.fillData()
      // this.calcRanking()
      this.calcStatusTable()
    },
    ff () {
      var value = this.offsetLocal + 7
      if (value > 0) {
        value = 0
      }
      this.offsetLocal = value
      this.fillData()
      // this.calcRanking()
      this.calcStatusTable()
    },
    left () {
      if (this.selected === 'Month') {
        if (this.offsetLocal === -6) {
          return
        }
      }
      if (this.selected === 'Week') {
        if (this.offsetLocal === -45) {
          return
        }
      }
      if (this.selected === 'Day') {
        if (this.offsetLocal === -358) {
          return
        }
      }
      this.offsetLocal -= 1
      this.fillData()
      // this.calcRanking()
      this.calcStatusTable()
      // }
    },
    today () {
      this.offsetLocal = 0
      this.fillData()
      // this.calcRanking()
      this.calcStatusTable()
    },
    right () {
      if (this.offsetLocal !== 0) {
        this.offsetLocal += 1
        this.fillData()
        // this.calcRanking()
        this.calcStatusTable()
      }
    },
    fillData () {
      var vm = this
      const data = {
        labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
        datasets: [
          {
            label: 'Achivement',
            backgroundColor: 'rgba(255,255,255,.3)',
            borderColor: 'white',
            borderWidth: 1,
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      }

      const option = {
        tooltips: {
          enabled: false
          // custom: CustomTooltips
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: true,
              // categoryPercentage: 1,
              // barPercentage: 0.5
              gridLines: {
                display: false
              },
              ticks: {
                fontColor: '#fff',
                fontSize: 10
              }
            }
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                fontColor: '#fff',
                fontSize: 10,
                beginAtZero: true,
                min: 0,
                max: 40
              }
            }
          ]
        },
        onClick: function (e, el) {
          if (!el || el.length === 0) return
          if (vm.selected === 'Month') {
            vm.offsetLocal = (vm.offsetLocal - (6 - el[0]._index)) * 4
            vm.isSelected = true
            vm.selected = 'Week'
          } else if (vm.selected === 'Week') {
            vm.offsetLocal = (vm.offsetLocal - (6 - el[0]._index)) * 7
            vm.isSelected = true
            vm.selected = 'Day'
          }
        }
      }
      var tempOption = option
      if (this.selected === 'Day') {
        tempOption.scales.yAxes[0].ticks.max = 32
      } else if (this.selected === 'Week') {
        tempOption.scales.yAxes[0].ticks.max = 32 * 7
      } else {
        tempOption.scales.yAxes[0].ticks.max = 32 * 28
      }
      this.options = {}
      this.options = tempOption
      var chartTemp = data
      var counter = 7
      if (this.selected === 'Month') {
        counter = 7
      }
      chartTemp.labels = Array(counter)
      chartTemp.datasets[0].data = Array(counter)
      chartTemp.labels.fill('')
      chartTemp.datasets[0].data.fill(0)
      if (this.selected === 'Day') {
        var objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 + this.offsetLocal)
        this.rankStart = moment(objDate).format('YYYY/MM/DD')
        objDate = new Date()
        objDate.setDate(objDate.getDate() + this.offsetLocal)
        this.rankEnd = moment(objDate).format('YYYY/MM/DD')

        for (var i = 0; i < counter; i++) {
          objDate = new Date()
          objDate.setDate(objDate.getDate() - 6 + this.offsetLocal + i)
          var str = moment(objDate).format('YYYY/MM/DD')
          const index = this.routineData.findIndex(
            routine => routine.dateText === str
          )
          if (index !== -1) {
            var routine = this.routineData[index]
            chartTemp.datasets[0].data[i] = routine.routineCounter.total.done
          }
          chartTemp.labels[i] = moment(objDate).format('MM/DD')
        }
      } else if (this.selected === 'Week') {
        objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 * 7 + this.offsetLocal * 7)
        this.rankStart = moment(objDate).format('YYYY/MM/DD')
        objDate = new Date()
        objDate.setDate(objDate.getDate() + this.offsetLocal * 7)
        this.rankEnd = moment(objDate).format('YYYY/MM/DD')

        for (i = 0; i < counter; i++) {
          objDate = new Date()
          objDate.setDate(objDate.getDate() - 6 * 7 + this.offsetLocal * 7 + i * 7)
          str = moment(objDate).format('YYYY/MM/DD')
          chartTemp.datasets[0].data[i] = this.week[45 + this.offsetLocal + i]
          chartTemp.labels[i] = moment(objDate).format('MM/DD')
        }
      } else {
        objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 * 28 + this.offsetLocal * 28)
        this.rankStart = moment(objDate).format('YYYY/MM/DD')
        objDate = new Date()
        objDate.setDate(objDate.getDate() + this.offsetLocal * 28)
        this.rankEnd = moment(objDate).format('YYYY/MM/DD')

        for (i = 0; i < counter; i++) {
          objDate = new Date()
          objDate.setDate(
            objDate.getDate() - 6 * 28 + this.offsetLocal * 28 + i * 28
          )
          str = moment(objDate).format('YYYY/MM/DD')
          chartTemp.datasets[0].data[i] = this.month[6 + this.offsetLocal + i]
          chartTemp.labels[i] = moment(objDate).format('MM/DD')
        }
      }
      this.chartData = chartTemp
    }
  },
  computed: {
    localOffset () {
      return this.offsetLocal
    },
    ...mapGetters({
      routines: 'routine/routines',
      routineGroups: 'routineGroup/routineGroups',
      routineRefs: 'routineRef/routineRefs',
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      data: 'dispatch/data',
      register: 'register/register',
      init: 'authUser/init',
      authUser: 'authUser/user'
    })
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    },
    momentMMDD: function (date) {
      return moment(date).format('MM/DD')
    }
  }
}
</script>

<style>
td {
  background-color: white;
}
th {
  white-space: nowrap;
}
.th-date {
  white-space: pre-line;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Achivement.vue